(function () {
    function initForHomeFlowAnimation() {
        var hero = document.querySelector('.stations-hero');
        if (!hero) return;

        var lines = hero.querySelectorAll('.stations-hero__flow-line');
        if (!lines.length || typeof window.gsap === 'undefined') return;

        var reverseFlow = hero.classList.contains('for-business-hero');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        var timeline = window.gsap.timeline({
            paused: true,
            repeat: -1,
            repeatDelay: 0.2
        });

        lines.forEach(function (line, index) {
            var pathLength = line.getTotalLength();
            var segmentCount = 6;
            var segmentLength = Math.min(8, pathLength / 12);
            var flowLength = segmentLength * segmentCount;
            var animationDuration = Math.max(1.4, (pathLength + flowLength) / 90);
            var insertionPoint = line;

            for (var segmentIndex = 0; segmentIndex < segmentCount; segmentIndex += 1) {
                var segment = line.cloneNode(false);
                var colorProgress = segmentIndex / (segmentCount - 1);
                var color = window.gsap.utils.interpolate(
                    '#DADC32',
                    '#FFFFFF',
                    colorProgress
                );
                var startOffset = reverseFlow
                    ? pathLength + (segmentIndex * segmentLength)
                    : -pathLength - (segmentIndex * segmentLength);
                var endOffset = reverseFlow
                    ? -flowLength + (segmentIndex * segmentLength)
                    : flowLength - (segmentIndex * segmentLength);

                segment.classList.remove('stations-hero__flow-line', 'for-home-hero__flow-line', 'for-business-hero__flow-line');
                segment.classList.add('stations-hero__flow-segment');
                insertionPoint.parentNode.insertBefore(segment, insertionPoint.nextSibling);
                insertionPoint = segment;

                timeline.fromTo(segment, {
                    opacity: 1,
                    stroke: color,
                    strokeDasharray: segmentLength + ' ' + (pathLength + flowLength),
                    strokeDashoffset: startOffset
                }, {
                    strokeDashoffset: endOffset,
                    duration: animationDuration,
                    ease: 'none'
                }, index * 0.6);
            }
        });

        if (!('IntersectionObserver' in window)) {
            timeline.play();
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    timeline.play();
                } else {
                    timeline.pause();
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(hero);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initForHomeFlowAnimation);
    } else {
        initForHomeFlowAnimation();
    }
})();
